export type APIErrorPayload = {
  error?: {
    code?: string
    message?: string
    fields?: Record<string, string>
  }
}

export type APIError = {
  code: string
  message: string
  fields: Record<string, string>
}

export function normalizeAPIError(payload: unknown): APIError {
  const body = payload as APIErrorPayload | undefined
  return {
    code: body?.error?.code ?? 'internal',
    message: body?.error?.message ?? 'request failed',
    fields: body?.error?.fields ?? {},
  }
}
